import React, { createContext, useContext, useState, useEffect } from 'react';

const WhatsAppContext = createContext();

export const WhatsAppProvider = ({ children }) => {
  const [whatsappConnected, setWhatsappConnected] = useState(false);
  const [qrCode, setQrCode] = useState(null);

  useEffect(() => {
    const checkWhatsAppStatus = async () => {
      try {
        const API_URL = process.env.REACT_APP_API_URL || '/api';
        const response = await fetch(`${API_URL}/whatsapp/status`, { credentials: 'include' });
        const data = await response.json();
        console.log('[WhatsAppContext] API Response:', data);
        // CHECK: true if connected is explicitly true and status is 'open' or 'connected'
        const isConnected = data.connected === true && (data.status === 'open' || data.status === 'connected');
        console.log('[WhatsAppContext] isConnected calculated:', isConnected);
        setWhatsappConnected(isConnected);
        
        if (data.qrCode) {
          setQrCode(data.qrCode);
        } else {
          setQrCode(null);
        }
      } catch (error) {
        console.error('[WhatsAppContext] Error checking WhatsApp status:', error);
        setWhatsappConnected(false);
      }
    };

    checkWhatsAppStatus();
    const interval = setInterval(checkWhatsAppStatus, 3000); // Check every 3 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <WhatsAppContext.Provider value={{ whatsappConnected, qrCode, setWhatsappConnected }}>
      {children}
    </WhatsAppContext.Provider>
  );
};

export const useWhatsApp = () => {
  const context = useContext(WhatsAppContext);
  if (!context) {
    throw new Error('useWhatsApp must be used within a WhatsAppProvider');
  }
  return context;
};

export default WhatsAppContext;
